
import {
	LoginWrapper,
	LeftSection,
	RightSection,
	LoginSection,
} from "./styled";
import { Heading } from "../../../../../components/Heading";

import rightImg from "./../../../../../icons/login-right-img.jpg";
import { Button } from "../../../../../components/Button";
import { LogoWrapper } from "../../../../../components/LogoWrapper/LogoWrapper";
import { useAuthContext } from "../../context/AuthContextProvider";

export const Suspended = ({ ...props }) => {
	const { logoutUser } = useAuthContext();  
  
	return (
		<LoginWrapper>
			<LeftSection>
				<LogoWrapper />

				<LoginSection>
					<Heading marginBottom="50px">
						<span>Account Suspended</span>
					</Heading>
					<p className="instructions">
						Your Account has been suspended. Please contact
						<a href="mailto:support@procuracon.com.au"> Procuracon Support </a>
						for more information.
					</p>

					<Button
						data-testid={"logout-button"}
						onClick={logoutUser}
					>
						Logout
					</Button>
				</LoginSection>
			</LeftSection>
			<RightSection
				style={{ backgroundImage: `url(${rightImg})` }}
			></RightSection>
		</LoginWrapper>
	);
};

export default Suspended;
